module.exports = __webpack_public_path__ + "img/mihai.a451ff89.png";